import React from "react";
import { Popup, Icon, List } from "semantic-ui-react";
import { formatErrorDate } from "./utils";

export const PdfErrorsTooltip = ({ hasPdfErrors, pdfErrors, lastUpdatedFillErrors }) => {
  if (!hasPdfErrors) return null;

  return (
    <div style={{
      marginTop: "8px"
    }}>
      <Popup
        trigger={
          <div style={{ color: "#db2828", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px" }}>
            <Icon name="exclamation triangle" style={{ margin: 0 }} />
            <span>PDF Errors</span>
            {lastUpdatedFillErrors && (
              <span style={{ fontSize: "11px", color: "#999" }}>
                {formatErrorDate(lastUpdatedFillErrors)}
              </span>
            )}
          </div>
        }
        content={
          <div style={{ maxWidth: "300px", userSelect: "text", cursor: "text" }}>
            <div style={{ fontWeight: "bold", marginBottom: "8px" }}>PDF Generation Errors:</div>
            {lastUpdatedFillErrors && (
              <div style={{ marginBottom: "8px", fontSize: "12px", color: "#666", fontStyle: "italic" }}>
                Last updated: {formatErrorDate(lastUpdatedFillErrors)}
              </div>
            )}
            <List bulleted>
              {pdfErrors.map((error, index) => (
                <List.Item key={index} style={{ userSelect: "text", cursor: "text" }}>{error}</List.Item>
              ))}
            </List>
          </div>
        }
        position="bottom left"
        wide="very"
        hoverable
        mouseEnterDelay={0}
        mouseLeaveDelay={500}
      />
    </div>
  );
};

export const PdfErrorsWarning = ({ hasPdfErrors, pdfErrors, lastUpdatedFillErrors }) => {
  if (!hasPdfErrors) return null;

  return (
    <div style={{ marginTop: "15px", padding: "10px", backgroundColor: "#fff3cd", border: "1px solid #ffeaa7", borderRadius: "4px" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
        <Icon name="exclamation triangle" style={{ color: "#856404", marginRight: "6px" }} />
        <span style={{ fontWeight: "bold", color: "#856404" }}>PDF Generation Errors:</span>
      </div>
      {lastUpdatedFillErrors && (
        <div style={{ marginBottom: "8px", fontSize: "12px", color: "#856404", fontStyle: "italic" }}>
          Last updated: {formatErrorDate(lastUpdatedFillErrors)}
        </div>
      )}
      <List style={{ margin: 0, color: "#856404" }}>
        {pdfErrors.map((error, index) => (
          <List.Item key={index} style={{ padding: "2px 0", fontSize: "13px" }}>
            • {error}
          </List.Item>
        ))}
      </List>
    </div>
  );
};